/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleUser } from '../models/SimpleUser';
import { HttpFile } from '../http/http';

export class HorseAccessHistory {
    'dtAdded': string;
    'dtRemoved'?: string;
    'user': SimpleUser;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "dtAdded",
            "baseName": "dtAdded",
            "type": "string",
            "format": "date"
        },
        {
            "name": "dtRemoved",
            "baseName": "dtRemoved",
            "type": "string",
            "format": "date"
        },
        {
            "name": "user",
            "baseName": "user",
            "type": "SimpleUser",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return HorseAccessHistory.attributeTypeMap;
    }

    public constructor() {
    }
}

